import classnames from "classnames";
import React from "react";

interface IAvisLogoProps {
  className?: string;
  handleClick?: React.MouseEventHandler<HTMLImageElement>;
}
export function AvisLogo(props: IAvisLogoProps) {
  const { className, handleClick } = props;

  const classNameForImg = classnames("avis-logo-img", className);
  return (
    <img
      className={classNameForImg}
      src="/akka_laa_logo.svg"
      alt="AKKA/LAA logo"
      onClick={handleClick}
    />
  );
}
